import { getUserTrialType } from '@revelio/auth';
import { MetadataKey, type TrialType, type User } from '@revelio/data-access';

export const formatExpirationDate = (expirationDate: string) => {
  const date = new Date(expirationDate);
  return Number.isNaN(date.getTime())
    ? expirationDate
    : date.toLocaleString(undefined, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      });
};

export const formatValueLabel = (value: string) => {
  const withSpaces = value
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  return withSpaces
    .split(' ')
    .map((segment) => {
      if (segment.length <= 3 && segment.toUpperCase() === segment) {
        return segment;
      }
      const lower = segment.toLowerCase();
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(' ');
};

export const getTrialUserFlag = (
  user: User | undefined
): boolean | undefined => {
  if (user?.live === false) {
    return true;
  }
  if (user?.live === true) {
    return false;
  }
  return undefined;
};

export const getExpirationDate = (user: User | undefined): string | undefined =>
  user?.metadata?.find((meta) => meta?.key === MetadataKey.ExpirationDate)
    ?.value ?? undefined;

export const getNormalizedTrialType = (
  user: User | undefined
): TrialType | undefined => {
  const trialType = user ? getUserTrialType(user) : undefined;
  return trialType === false ? undefined : trialType;
};
